import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Card, CardHeader, Box,Skeleton } from '@mui/material';
// components
import { useChart } from '../../../components/chart';
import { useState } from 'react';

// ----------------------------------------------------------------------

AppWebsiteVisits.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default function AppWebsiteVisits({ title, subheader, chartLabels, chartColors, chartData , ...other }) {
  
  const chartOptions = useChart({
    plotOptions: { bar: { columnWidth: '16%' } },
    fill: { type: chartData.map((i) => i.fill) },
    colors: chartColors || ['#008FFB', '#00E396', '#FEB019'],
    labels: chartLabels,
    xaxis: { type: 'category' },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)}`;
          }
          return y;
        },
      },
    },
  });

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
      {!other?.loading ? (
        <ReactApexChart type="line" series={chartData} options={chartOptions} height={364} />
        ) : (
          <Skeleton animation="wave" variant="rectangular" width="100%"  height={380} sx={{borderRadius:2}}/>
        )}

      </Box>
    </Card>
  );
}
